import styled from 'styled-components'

export const CustomInput = styled.input`
  outline: none;
  &::placeholder {
    color: var(--gray-600);
  }
`

CustomInput.displayName = 'CustomInputPostModalContent'

export const InputCounter = styled.div`
  bottom: 0;
  right: 0;
`

InputCounter.displayName = 'InputCounter'
